module.exports = __webpack_public_path__ + "static/media/18_pol_0_84.54.8c42199d.png";